import { RESOURCE_NAME as BITRIXES } from '@esentai/core/features/bitrixes/consts';
import { permit } from '@esentai/core/policy-dsl';

import { BITRIX } from '@/features/bitrixPage/consts/permissions';

export default [permit(BITRIXES, [BITRIX])];
